<script lang="ts" setup>
import {useI18n} from 'vue-i18n';

const {t: $t} = useI18n();
</script>
<template>
  <span class="recommended-pill" aria-hidden="true">{{ $t('recco_recommended') }}</span>
</template>
<style lang="scss" scoped>
// Corner marker overlaid on a card's media (parent must be positioned).
.recommended-pill {
  @include card-image-chip-inverted;
  position: absolute;
  bottom: var(--Spacing-spacing-3);
  left: var(--Spacing-spacing-3);
  z-index: 2;
}
</style>
